import React from 'react'
import RESOURCE_TYPES from '../../../constants/resource-types'

const LearningResourceTypeLabel = ({
    resource = {}
}) => {
    const type = resource.type || RESOURCE_TYPES.LINK

    return (
        <React.Fragment>
            {type.toUpperCase()}
        </React.Fragment>
    )
}

export default LearningResourceTypeLabel